import { selectVirtualBackgroundSyncConfig } from 'features/virtual-backgrounds/selectors';
import React, { useEffect, useMemo, useRef } from 'react';
import { PreviewFormValues } from 'features/join/publisher/JoinPreview';
import { SubmitHandler } from 'react-hook-form';
import JoinPublisherLayout from 'features/join/publisher/JoinPublisherLayout';
import { roomJoinRequest } from 'features/room/actions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { BroadcastSetupContextProvider, useBroadcastSetupMedia } from 'utils/broadcast-setup';

const JoinPublisher = () => {
  const appDispatch = useAppDispatch();

  const didInitRef = useRef(false);

  const {
    onAudioOutputChange,
    onAudioInputChange,
    onVideoInputChange,
    onAudioToggle,
    onVideoToggle,
    dispatch,
    enableAudio,
    disableAudio,
    disableCamera,
    enableCamera,
    requestPermissions,
    pendingMedia,
    videoStream,
    audioStream,
    resetVB,
    changeVB,
    changeVBEffect,
    state: { audio, video, status },
  } = useBroadcastSetupMedia({
    reason: 'join',
  });

  const syncVBConfig = useAppSelector(selectVirtualBackgroundSyncConfig);

  useEffect(() => {
    if (!didInitRef.current) {
      didInitRef.current = true;
      requestPermissions();
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    changeVBEffect(videoStream, syncVBConfig);
  }, [syncVBConfig, videoStream]);

  const handleJoinWithoutDevices = () => {
    appDispatch(roomJoinRequest());
  };

  const handleJoinRoom: SubmitHandler<PreviewFormValues> = () => {
    appDispatch(roomJoinRequest());
  };

  const contextValue = useMemo(
    () => ({
      video,
      audio,
      videoStream,
      audioStream,
      onVideoToggle,
      onAudioToggle,
      onAudioInputChange,
      onAudioOutputChange,
      onVideoInputChange,
      enableAudio,
      disableAudio,
      disableCamera,
      enableCamera,
      dispatch,
      resetVB,
      changeVB,
    }),
    [
      video,
      audio,
      videoStream,
      audioStream,
      onVideoToggle,
      onAudioToggle,
      onAudioInputChange,
      onAudioOutputChange,
      onVideoInputChange,
      enableAudio,
      disableAudio,
      disableCamera,
      enableCamera,
      dispatch,
      resetVB,
      changeVB,
    ]
  );

  return (
    <BroadcastSetupContextProvider value={contextValue}>
      <JoinPublisherLayout
        joinWithoutDevices={handleJoinWithoutDevices}
        onReload={pendingMedia.reload}
        onJoinWithoutMedia={pendingMedia.joinWithoutMedia}
        status={status}
        joinRoom={handleJoinRoom}
      />
    </BroadcastSetupContextProvider>
  );
};

export default JoinPublisher;
